import React from 'react'
import { connect, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';

const withDefaults = WrappedComponent => {
  const mapStateToProps = (state) => ({
    content: state.content,
    user: state.user,
    page: state.page,
    territory: state.territory,
    environment: state.environment
  });

  const WithDefaults = (props) => {
    return(
      <WrappedComponent{...props} dispatch={useDispatch()} />
    )
  }
  return connect(mapStateToProps)(injectIntl(WithDefaults))
}

export default withDefaults
